import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type Insured from '@/modules/common/common/models/APP/Insured'
import ExistClientRequest from '@/modules/common/hiring/models/MID/requests/ExistClientRequest'

export default class ExistClientMapper {
  static toRequest(holder: Insured): ExistClientRequest {
    return new ExistClientRequest({
      firstSurname: (holder.userDetails.surname1 ?? '')?.toUpperCase(),
      secondSurname: (holder.userDetails.surname2 ?? '')?.toUpperCase(),
      name: (holder.userDetails.name ?? '')?.toUpperCase(),
      sex: holder.userDetails.gender,
      documentType: holder.documentDetails.documentType,
      documentNumber: holder.documentDetails.documentNumber,
      birthDay: holder?.userDetails?.birthDate
        ? CommonMapper.toMiddlewareDate(holder.userDetails.birthDate)
        : null
    })
  }
}
